<template>
  <form class="form" method="post">

    <div id="appTarifCreateVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Ajouter un tarif</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Catégorie*</p>
            <p class="appLabelStyle1">Nom*</p>
          </div>
          <div class="appGroupOfInput">
            <select v-model="category" type="string" name="category" class="appInputStyle1">
              <option valeur="Femmes">Femmes</option>
              <option valeur="Femmes">Suppléments</option>
              <option valeur="Femmes">Cérémonie</option>
              <option valeur="Hommes">Hommes</option>
              <option valeur="Enfants">Enfants</option>
              <option valeur="Enfants">Soins</option>
            </select>
            <input v-model="name" type="string" name="name" class="appInputStyle1" placeholder="Nom de la prestation">
          </div>
        </div>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle1">Prix</p>
            <p class="appLabelStyle1">S</p>
            <p class="appLabelStyle1">M</p>
            <p class="appLabelStyle1">L</p>
            <p class="appLabelStyle1">XL</p>
          </div>
          <div class="appGroupOfInput2">
            <input v-model="priceUnique" type="number" step=".01" name="priceUnique" class="appInputStyle1">
            <input v-model="priceS" type="number" step=".01" name="priceS" class="appInputStyle1">
            <input v-model="priceM" type="number" step=".01" name="priceM" class="appInputStyle1">
            <input v-model="priceL" type="number" step=".01" name="priceL" class="appInputStyle1">
            <input v-model="priceXL" type="number" step=".01" name="priceXL" class="appInputStyle1">
          </div>
        </div>
      </div>
      <br>
      <button @click.prevent="createTarif()" type="submit" class="appButtonModel2">Ajouter mon tarif</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'TarifCreate',
  data () {
    return {
      category: '',
      name: '',
      priceUnique: '',
      priceS: '',
      priceM: '',
      priceL: '',
      priceXL: '',
      errorMsg: ''
    }
  },
  methods: {
    createTarif () {
      if (this.category !== null || this.name !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        axios
          .post('https://privilegia.fr/api/tarifs', {
            userId: decryptedToken.userId,
            category: this.category.toUpperCase(),
            name: this.name,
            priceUnique: this.priceUnique,
            priceS: this.priceS,
            priceM: this.priceM,
            priceL: this.priceL,
            priceXL: this.priceXL
          }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
          .then((response) => {
            window.alert('Nouveau tarif ajouté')
            this.$router.push('/App/Tarifs')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner la catégorie et le nom'
            console.log(error.response.data)
          })
      } else {
        this.errorMsg = 'Merci de renseigner la catégorie et le nom'
      }
    }}}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppTarifsCreate.vue